import React, { useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LiliButton } from '@lili/lili-frontend-common';
import { ReactComponent as HeaderIcon } from '../../../assets/icons/svg/icon-new-lili-logo.svg';
import Heading from '../../../generic-components/Heading';
import { GET_STARTED_ERRORS_MAP } from '../consts';
import { VIEWS_MAP } from '../../../router/constants';

export const OnboardingFailed = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  /** Get router param "case" */
  const params = useParams();
  /** Render content by the case type */
  const pageContent = useMemo(() => {
    switch (params.case) {
      case GET_STARTED_ERRORS_MAP.AUTHORIZED_USER_NOT_FOUND.toString():
      case GET_STARTED_ERRORS_MAP.AUTHORIZED_USER_INVITE_CANCELED.toString():
        return {
          header: t('ACCOUNTANT_OB_ERRORS.A.TITLE'),
          body: t('ACCOUNTANT_OB_ERRORS.A.CONTENT'),
        };

      case GET_STARTED_ERRORS_MAP.AUTHORIZED_USER_INVITE_EXPIRED.toString():
        return {
          header: t('ACCOUNTANT_OB_ERRORS.B.TITLE'),
          body: t('ACCOUNTANT_OB_ERRORS.B.CONTENT'),
        };

      case GET_STARTED_ERRORS_MAP.AUTHORIZED_USER_ALREADY_COMPLETE_ONBOARDING_2.toString():
      case GET_STARTED_ERRORS_MAP.AUTHORIZED_USER_ALREADY_REGISTER.toString():
        return {
          header: t('ACCOUNTANT_OB_ERRORS.C.TITLE'),
          body: t('ACCOUNTANT_OB_ERRORS.C.CONTENT'),
          cta: t('ACCOUNTANT_OB_ERRORS.C.CTA'),
        };

      default:
        return {
          header: t('ACCOUNTANT_OB_ERRORS.A.TITLE'),
          body: t('ACCOUNTANT_OB_ERRORS.A.CONTENT'),
        };
    }
  }, [params]);

  return (
    <div className='w-full h-full bg-bw02 pl-[102px]'>
      <div className='pl-[103px] pr-[220px] pt-[10%] flex flex-col w-fit h-full items-baseline bg-bw00'>
        <HeaderIcon className='w-[80px]' />
        <Heading
          title={pageContent.header}
          className='font-metricRSemibold text-bw07 text-[30px] break-words max-w-[315px] mb-[24px]'
        />
        <Heading title={pageContent.body} className='font-metricR text-bw07 text-[16px] break-words max-w-[335px]' />
        {pageContent.cta && (
          <div className='w-[200px] mt-[32px]'>
            <LiliButton onClick={() => navigate(`/${VIEWS_MAP.LOGIN}`)} id='logIn' title={pageContent.cta} />
          </div>
        )}
      </div>
    </div>
  );
};
